import { useEffect, useRef, useState } from "react";
import AdminNav from "./AdminNav";
import Events from "./Events.jsx";
// import logo from "./assets/logo.png"
import ManageNotification from "./MangeNotification";
import CreateEvent from "./CreateEvent";
import EditEventForm from "./EditEventForm";
import { useLocation, useNavigate } from "react-router-dom";
import EditClientForm from "./EditClientForm";
import { toast } from "react-toastify";
import useDealerships from "./useDealerships";
import Users from "./Users";
import Signup from "./createUser";
import EditUser from "./EditUserForm";
import UserProfile from "./userProfile";
import Dealership from "./Dealership";
import Loader from "./loader.jsx";
import Footer from "./footer.js";
import {
  allTypes,
  externalUsers,
  internalUsers,
  rolesThatCanCreateUsers,
} from "./constants/userTypes.js";
import CreatePrivateEvent from "./createPrivateEvent.jsx";
import Forms from "./Forms.jsx";
import useAllUsers from "./useAllUsers.jsx";
import ClientDashboard from "./ClientDashboard.jsx";
import BillingReport from "./billingReports.jsx";
import EventReport from "./eventReport.jsx";
import SalesReport from "./salesReport.jsx";
import EvenView from "./components/evenView.jsx";
import Clients from "./components/clients.jsx";
import CreateProspective from "./components/createProspective.jsx";
import Appointments from "./pages/appointments/appointments.jsx";
import EditAppointmentForm from "./pages/appointments/components/editAppointmentForm.jsx";
import { ApiUrl } from "./ApiUrl.jsx";
import useDealerships2 from "./hooks/useDealerships2.jsx";
import EventReport2 from "./pages/eventReport/eventReport.jsx";
import StatusReport from "./pages/statusRepor/statusReport.jsx";
import BlackList from "./pages/blackList/blackList.jsx";
import AgentBonusReport from "./pages/agentBonusReport/agentBonusReport.jsx";
import BonusConfirmation from "./pages/bonusConfirmationReport/bonusConfirmation.jsx";
import CopyClient from "./pages/copyClient/copyClient.jsx";
import ViewClientSubmission from "./ViewClientSubmission.jsx";
import EventsNew from "./EventsNew.jsx";
import { useLanguage } from "./languageContext";
import translations from "./translation.json";
import useGroups from "./useGroups.jsx";
import NewReport from "./pages/newReport/newReport.jsx";
import CallbackList from "./components/callbackList.jsx";


var currentUrl = window.location.href;



const EventPortal = ({ setIsDarkMode, isDarkMode }) => {
  const { language } = useLanguage();
  const eventsFilterData = JSON.parse(localStorage.getItem("eventsFilterData"));
  const [displayComponent, setDisplayComponent] = useState();
  // const [searchParams]=useSearchParams()
  const navigate = useNavigate();
  const [events, setEvents] = useState({});
  const [stats, setStats] = useState({});
  const [totalEvents, setTotalEvents] = useState(0);
  const [showTable, setShowTable] = useState(false);
  const [eventTrigger, setEventTrigger] = useState();
  const [listId, seListId] = useState({ list_id: "", list_name: "" });
  // Check if the token exists in local storage
  const [token, setToken] = useState(localStorage.getItem("token"));
  const [editEventID, setEditEventID] = useState(0); //To get event ID form events component, which event form have to be edited
  const [editClientID, setEditClientID] = useState(0); //To get Client ID from Edit Events component, which client form have to be edited
  const userType = localStorage.getItem("userType");
  const userData = JSON.parse(localStorage.getItem("userData"));
  const [checkedFields, setCheckedFields] = useState(eventsFilterData || []);
  
  const [prevDisplay, setPrevDisplay] = useState(displayComponent);
  //dealerships
  const [dealerTrigger, setDealerTrigger] = useState(false);
  const dealerships = useDealerships(token, dealerTrigger);
  const groups = useGroups(token);
  const dealershipsDropdown = useDealerships2(token, dealerTrigger);
  const users = useAllUsers(token, dealerTrigger);
  const [dealerships2, setDealerships2] = useState([]);
  const [dealerships3, setDealerships3] = useState([]);

  // const allTypes = ["admin", "manager", "representative", "animator"];
  const [isLoading, setIsLoading] = useState(false);
  const [key, setKey] = useState("");
  const [total, setTotal] = useState();
  const [searchCache, setSearchCache] = useState({});
  const [pageCache, setPageCache] = useState({});
  const [deleteStates, setDeleteStates] = useState();
  const [pageNo, setPageNo] = useState(1);
  const [showDealerDropDown, setShowDealerDropDown] = useState(false);

  // Dealership States
  const [dealerships0, setDealerships0] = useState([]);
  const [dealershipSearch, setDealershipSearch] = useState();
  const [DealershipPageCache, setDealershipPageCache] = useState({});
  const [totalDealership, setTotalDealership] = useState();
  const [DealershippageNo, setDealershipPageNo] = useState(1);
  const [deleteStatesDealership, setDeleteStatesDealership] = useState();

  // Users Page States
  const dealershipFilter = JSON.parse(localStorage.getItem("dealershipFilter"));
  const provinceFilter = JSON.parse(localStorage.getItem("provinceFilter"));
  const [usersData, setusers] = useState([]);
  // const [dealershipSearch, setDealershipSearch] = useState();
  const [totalUsers, setTotalUsers] = useState();
  const [deleteStatesUsers, setDeleteStatesUsers] = useState();
  const [selectedOption, setSelectedOption] = useState(dealershipFilter || []);
  const [selectedProvince, setSelectedProvince] = useState(provinceFilter || []);
  const [dealershipLabel, setDealershipLabel] = useState(null);
  const selectedOptionRef = useRef(null);
 const [dataEnd, setDataEnd] = useState(false);
const [dataLoaded, setDataLoaded] = useState(false);
const [repOptions2, setrepOptions2] = useState([]);
  const [managers, setmanagers] = useState([]);
  const [packageOptions, setpackageOptions] = useState([]);
   const isFetchingRef = useRef(false);
  const filterOptions = [
    {
      label: translations.EventsPortal.filterOptions.currentYear[language],
      value: "currentYear",
    },
    {
      label: "Archive",
      value: "previousYear",
    },
    {
      label: translations.EventsPortal.filterOptions.futureYear[language],
      value: "future",
    },
    {
      label:
        translations.usersPage.createUser.statusOptions.cancelled[language],
      value: "cancel",
    },
  ];
  const [filterOption, setFilterOption] = useState(filterOptions[0].value);

  const redirectPages = [
    "clients",
    "appointments",
    "event-view",
    "create-prospective",
    "edit-prospective",
    "edit-appointment",
    "add-appointment",
    "view-sales-report",
    "eventReport",
    "status-report",
    "event-status-report",
    "copy-client",
  ];
  // useEffect(() => {
  // const elementsToStyleLight = document.querySelectorAll(
  //   'h1, h2, h3, h4, h5, h6, p, ul, li, span, table, td, tr, thead,div, th, body, nav, .navbar, label'
  // );

  // const elementsToStyleDark = document.querySelectorAll(
  //   '.App, .container, .event-portal, .dark-light, .footertext, .modal-content div'
  // );

  // if (isDarkMode) {
  //   document.documentElement.style.setProperty('--color-background', '#1f2023');
  //   document.documentElement.style.setProperty('--color-text', '#fff');
  //   document.documentElement.style.setProperty('--color-background-second', '#000');
  // } else {
  //   document.documentElement.style.setProperty('--color-background', '#fff');
  //   document.documentElement.style.setProperty('--color-text', '#000');
  //   document.documentElement.style.setProperty('--color-background-second', '#F5F5FB');
  // }

  // Apply styles for text color and background color in light mode
  // elementsToStyleLight.forEach((element) => {
  //   if (isDarkMode) {
  //     element.classList.toggle('dark-mode-text', isDarkMode);
  //     // Apply the light mode class only if dark mode is not active
  //     element.classList.toggle('dark-mode-bg-light', isDarkMode);
  //   } else {
  //     element.classList.remove('dark-mode-bg-light');
  //     element.classList.remove('dark-mode-text');
  //   }
  // });
  // // Apply styles for text color and background color in dark mode
  // elementsToStyleDark.forEach((element) => {
  //   if (isDarkMode) {
  //     element.classList.toggle('dark-mode-text', isDarkMode);
  //     // Remove the light mode class if dark mode is active
  //     element.classList.remove('dark-mode-bg-light');
  //     element.classList.toggle('dark-mode-bg-dark', isDarkMode);
  //   } else {
  //     element.classList.remove('dark-mode-text');
  //     element.classList.remove('dark-mode-bg-dark');
  //   }
  // });

  // }, [isDarkMode, displayComponent]);
  // // Use state to store the dealerships
  // const [dealerships, setDealerships] = useState(dealershipsHook);

  useEffect(() => {
    // If the token exists, redirect to "/event-portal"
    if (!token) {
      navigate("/");
    } else {
      // console.log('usertype eventportal', userType)
      if (externalUsers.includes(userType)) {
        // navigate("/client-form", { replace: true });
        // navigate("/event-portal", { replace: true });
      } else if (internalUsers.includes(userType)) {
        // navigate("/event-portal", { replace: true });
      } else {
        toast.error(translations.alertMessages.wentWrong[language]);
        navigate("/", { replace: true });
      }
    }

    const dealerData0 =
      dealerships && dealerships.length > 0
        ? dealerships.map((item) => ({
            label: item.name,
            value: item.id,
          }))
        : [];

    setDealerships3(dealerData0);

    const dealerData1 =
      dealershipsDropdown && dealershipsDropdown.length > 0
        ? dealershipsDropdown.map((item) => ({
            label: item.name,
            value: item.id,
          }))
        : [];

    setDealerships2(dealerData1);
  }, [token, userType, dealershipsDropdown, dealerships]);

  // Get the current URL

  // Find the index of '=' in the URL
  var equalsIndex = currentUrl.indexOf("=");
  // Check if '=' is found and extract the text after it
  useEffect(() => {
    currentUrl = window.location.href;
    if (equalsIndex !== -1) {
      const questionMarkIndex = currentUrl.indexOf("&", equalsIndex);
      const endIndex = questionMarkIndex !== -1 ? questionMarkIndex : undefined;
      setDisplayComponent(currentUrl.slice(equalsIndex + 1, endIndex));
      // console.log("Text after '=':", displayComponent);
    } else {
      // console.log("No '=' found in the URL");
      setDisplayComponent("events");
    }
    // if (currentUrl.includes("page=events")) {
    //   setShowDealerDropDown(true);
    // } else {
    //   setShowDealerDropDown(false);
    // }
  });

  // const queryParams = new URLSearchParams(location.search);
  // setPage(queryParams.get('page'));
  // console.log("===========> ", displayComponent)
  // setPage(textAfterEquals)
  window.onpopstate = function (e) {
    // console.log(e);
    if (e.state) {
      currentUrl = window.location.href;
      if (equalsIndex !== -1) {
        setDisplayComponent(currentUrl.slice(equalsIndex + 1));
        // console.log("-----------------------------------Text after '=':", displayComponent);
      } else {
        // console.log("------------------------------------No '=' found in the URL");
        setDisplayComponent("events");
      }
      // setDisplayComponent((prev) => {
      //   if (prev === 'editclient') return 'editevent'
      //   else if (prev === 'editevent') return 'events'
      //   else return prevDisplay
      // })
    }
  };

  const Tabs = [
    {
      title: "events",
      userTypes: allTypes,
      component: (
        // <Events
        <EventsNew
        isFetchingRef={isFetchingRef}
        setrepOptions2={setrepOptions2}
        setmanagers={setmanagers}
        setpackageOptions={setpackageOptions}
        packageOptions={packageOptions}
        managers={managers}
        repOptions2={repOptions2}
        filterOption={filterOption}
        setFilterOption={setFilterOption}
          setDisplayComponent={setDisplayComponent}
          eventTrigger={eventTrigger}
          setEventTrigger={setEventTrigger}
          setEditEventID={setEditEventID}
          setIsDarkMode={setIsDarkMode}
          isDarkMode={isDarkMode}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          users={users}
          groups={groups}
          dealerships={dealerships}
          setPrevDisplay={setPrevDisplay}
          events={events}
          setEvents={setEvents}
          stats={stats}
          setStats={setStats}
          key={key}
          setKey={setKey}
          total={total}
          setTotal={setTotal}
          searchCache={searchCache}
          setSearchCache={setSearchCache}
          setPageCache={setPageCache}
          pageCache={pageCache}
          deleteStates={deleteStates}
          setDeleteStates={setDeleteStates}
          pageNo={pageNo}
          setPageNo={setPageNo}
          selectedDealershipOption={selectedOption}
          selectedProvince={selectedProvince}
          setSelectedProvince={setSelectedProvince}
          setSelectedDealership={setSelectedOption}
          totalEvents={totalEvents}
          setTotalEvents={setTotalEvents}
          setDealershipLabel={setDealershipLabel}
          selectedOptionRef={selectedOptionRef}
          checkedFields={checkedFields}
          setCheckedFields={setCheckedFields}
          dataEnd={dataEnd}
          setDataEnd={setDataEnd}
          dataLoaded={dataLoaded}
          setDataLoaded={setDataLoaded}
        />
      ),
    },
    {
      title: "forms",
      userTypes: allTypes,
      component: (
        <Forms
          setDisplayComponent={setDisplayComponent}
          eventTrigger={eventTrigger}
          setEventTrigger={setEventTrigger}
          setEditEventID={setEditEventID}
          setIsDarkMode={setIsDarkMode}
          isDarkMode={isDarkMode}
        />
      ),
    },
    {
      title: "user-profile",
      userTypes: allTypes,
      component: (
        <UserProfile setIsLoading={setIsLoading} isDarkMode={isDarkMode} />
      ),
    },
    {
      title: "create-event",
      userTypes: allTypes,
      component: (
        <CreateEvent
          setDisplayComponent={setDisplayComponent}
          dealerships={dealerships}
          setDealerTrigger={setDealerTrigger}
          setIsLoading={setIsLoading}
          isDarkMode={isDarkMode}
          users={users}
        />
      ),
    },
    {
      title: "create-privateEvent",
      userTypes: allTypes,
      component: (
        <CreatePrivateEvent
          setDisplayComponent={setDisplayComponent}
          dealerships={dealerships}
          setDealerTrigger={setDealerTrigger}
          setIsLoading={setIsLoading}
          isDarkMode={isDarkMode}
          users={users}
        />
      ),
    },
    {
      title: "dealership",
      userTypes: allTypes,
      component: (
        <Dealership
          setDealerTrigger={setDealerTrigger}
          setIsLoading={setIsLoading}
          isDarkMode={isDarkMode}
          users={users}
          dealerships={dealerships0}
          setDealerships={setDealerships0}
          pageCache={DealershipPageCache}
          setPageCache={setDealershipPageCache}
          dealershipSearch={dealershipSearch}
          setDealershipSearch={setDealershipSearch}
          total={totalDealership}
          setTotal={setTotalDealership}
          pageNo={DealershippageNo}
          setPageNo={setDealershipPageNo}
          deleteStates={deleteStatesDealership}
          setDeleteStates={setDeleteStatesDealership}
          selectedDealershipOption={selectedOption}
          selectedProvince={selectedProvince}
          
        />
      ),
    },
    {
      title: "notifications",
      userTypes: allTypes,
      component: <ManageNotification setIsLoading={setIsLoading} />,
    },
    {
      title: "edit-event",
      userTypes: allTypes,
      component: (
        <CreatePrivateEvent
          setDisplayComponent={setDisplayComponent}
          dealerships={dealerships}
          setDealerTrigger={setDealerTrigger}
          setIsLoading={setIsLoading}
          isDarkMode={isDarkMode}
          editMode={true}
          users={users}
        />
      ),
    },
    {
      title: "edit-form",
      userTypes: allTypes,
      component: (
        <EditEventForm
          isDarkMode={isDarkMode}
          setDisplayComponent={setDisplayComponent}
          setEditClientID={setEditClientID}
          users={users}
        />
      ),
    },
    {
      title: "create-user",
      userTypes: rolesThatCanCreateUsers,
      component: (
        <Signup
          setDisplayComponent={setDisplayComponent}
          setIsLoading={setIsLoading}
          isLoading={isLoading}
          isDarkMode={isDarkMode}
        />
      ),
    },
    {
      title: "edit-user",
      userTypes: allTypes,
      component: (
        <EditUser
          setDisplayComponent={setDisplayComponent}
          setIsLoading={setIsLoading}
          isDarkMode={isDarkMode}
        />
      ),
    },
    {
      title: "edit-client",
      userTypes: allTypes,
      component: (
        <EditClientForm
          setDisplayComponent={setDisplayComponent}
          editClientID={editClientID}
          editEventID={editEventID}
          setIsLoading={setIsLoading}
          isDarkMode={isDarkMode}
        />
      ),
    },
    {
      title: "manage-users",
      userTypes: allTypes,
      component: (
        <Users
          setDisplayComponent={setDisplayComponent}
          setIsLoading={setIsLoading}
          isDarkMode={isDarkMode}
          usersData={usersData}
          setusers={setusers}
          total={totalUsers}
          setTotal={setTotalUsers}
          deleteStates={deleteStatesUsers}
          setDeleteStates={setDeleteStatesUsers}
          selectedDealershipOption={selectedOption}
        />
      ),
    },

    {
      title: "view-submissons",
      userTypes: allTypes,
      component: (
        <ClientDashboard
          setIsDarkMode={setIsDarkMode}
          isDarkMode={isDarkMode}
          setDisplayComponent={setDisplayComponent}
          setPrevDisplay={setPrevDisplay}
        />
      ),
    },
    {
      title: "view-billing-report",
      userTypes: allTypes,
      component: (
        <BillingReport
          setDisplayComponent={setDisplayComponent}
          eventTrigger={eventTrigger}
          setEventTrigger={setEventTrigger}
          setEditEventID={setEditEventID}
          setIsDarkMode={setIsDarkMode}
          isDarkMode={isDarkMode}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          users={users}
          dealerships={dealerships}
          setPrevDisplay={setPrevDisplay}
          events={events}
          setEvents={setEvents}
          // setDealerships2={setDealerships2}
          key={key}
          setKey={setKey}
          total={total}
          setTotal={setTotal}
          searchCache={searchCache}
          setSearchCache={setSearchCache}
          setPageCache={setPageCache}
          pageCache={pageCache}
          deleteStates={deleteStates}
          setDeleteStates={setDeleteStates}
          pageNo={pageNo}
          setPageNo={setPageNo}
          selectedOption={selectedOption}
        />
      ),
    },
    {
      title: "view-event-report",
      userTypes: allTypes,
      component: (
        <EventReport
          setDisplayComponent={setDisplayComponent}
          eventTrigger={eventTrigger}
          setEventTrigger={setEventTrigger}
          setEditEventID={setEditEventID}
          setIsDarkMode={setIsDarkMode}
          isDarkMode={isDarkMode}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          users={users}
          dealerships={dealerships}
          setPrevDisplay={setPrevDisplay}
          events={events}
          setEvents={setEvents}
          // setDealerships2={setDealerships2}
          key={key}
          setKey={setKey}
          total={total}
          setTotal={setTotal}
          searchCache={searchCache}
          setSearchCache={setSearchCache}
          setPageCache={setPageCache}
          pageCache={pageCache}
          deleteStates={deleteStates}
          setDeleteStates={setDeleteStates}
          pageNo={pageNo}
          setPageNo={setPageNo}
          selectedOption={selectedOption}
        />
      ),
    },
    {
      title: "view-sales-report",
      userTypes: allTypes,
      component: (
        <SalesReport
          setDisplayComponent={setDisplayComponent}
          eventTrigger={eventTrigger}
          setEventTrigger={setEventTrigger}
          setEditEventID={setEditEventID}
          setIsDarkMode={setIsDarkMode}
          isDarkMode={isDarkMode}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          users={users}
          dealerships={dealerships}
        />
      ),
    },
    {
      title: "event-view",
      userTypes: allTypes,
      component: (
        <EvenView
          isDarkMode={isDarkMode}
          setDisplayComponent={setDisplayComponent}
          setPrevDisplay={setPrevDisplay}
          setIsLoading={setIsLoading}
        />
      ),
    },
    {
      title: "clients",
      userTypes: allTypes,
      component: (
        <Clients
          isDarkMode={isDarkMode}
          setDisplayComponent={setDisplayComponent}
          setPrevDisplay={setPrevDisplay}
          seListId={seListId}
          setIsLoading={setIsLoading}
        />
      ),
    },
    {
      title: "callback-list",
      userTypes: [
        "Super Admin",
        "Admin",
        "Representative",
        "Animator",
      ],
      component: (
        <CallbackList
          isDarkMode={isDarkMode}
          setDisplayComponent={setDisplayComponent}
          setPrevDisplay={setPrevDisplay}
          seListId={seListId}
          setIsLoading={setIsLoading}
        />
      ),
    },
    {
      title: "copy-client",
      userTypes: allTypes,
      component: (
        <CopyClient
          isDarkMode={isDarkMode}
          setDisplayComponent={setDisplayComponent}
          setPrevDisplay={setPrevDisplay}
          seListId={seListId}
          dealerships2={dealerships2}
        />
      ),
    },
    {
      title: "create-prospective",
      userTypes: allTypes,
      component: (
        <CreateProspective
          isDarkMode={isDarkMode}
          setDisplayComponent={setDisplayComponent}
          setPrevDisplay={setPrevDisplay}
          setIsLoading={setIsLoading}
          users={users}
          listId={listId}
        />
      ),
    },
    {
      title: "edit-prospective",
      userTypes: allTypes,
      component: (
        <CreateProspective
          isDarkMode={isDarkMode}
          setDisplayComponent={setDisplayComponent}
          setPrevDisplay={setPrevDisplay}
          editMode={true}
          setIsLoading={setIsLoading}
          users={users}
          listId={listId}
        />
      ),
    },
    {
      title: "appointments",
      userTypes: allTypes,
      component: (
        <Appointments
          isDarkMode={isDarkMode}
          setDisplayComponent={setDisplayComponent}
          setPrevDisplay={setPrevDisplay}
          setIsLoading={setIsLoading}
          users={users}
          showTable={showTable}
          setShowTable={setShowTable}
        />
      ),
    },
    {
      title: "add-appointment",
      userTypes: allTypes,
      component: (
        <EditAppointmentForm
          isDarkMode={isDarkMode}
          setDisplayComponent={setDisplayComponent}
          setPrevDisplay={setPrevDisplay}
          // editMode={true}
          setIsLoading={setIsLoading}
          users={users}
          listId={listId}
        />
      ),
    },
    {
      title: "edit-appointment",
      userTypes: allTypes,
      component: (
        // <EditAppointmentForm
        //   isDarkMode={isDarkMode}
        //   setDisplayComponent={setDisplayComponent}
        //   setPrevDisplay={setPrevDisplay}
        //   editMode={true}
        //   setIsLoading={setIsLoading}
        //   users={users}
        // />
        <CreateProspective
          isDarkMode={isDarkMode}
          setDisplayComponent={setDisplayComponent}
          setPrevDisplay={setPrevDisplay}
          editMode={true}
          setIsLoading={setIsLoading}
          users={users}
          listId={listId}
          displayComponent={displayComponent}
        />
      ),
    },
    {
      title: "eventReport",
      userTypes: allTypes,
      component: (
        <EventReport2
          isDarkMode={isDarkMode}
          setDisplayComponent={setDisplayComponent}
          setPrevDisplay={setPrevDisplay}
          setIsLoading={setIsLoading}
          isLoading={isLoading}
        />
      ),
    },
    {
      title: "reports",
      userTypes: allTypes,
      component: (
        <NewReport
          isDarkMode={isDarkMode}
          setDisplayComponent={setDisplayComponent}
          setPrevDisplay={setPrevDisplay}
          setIsLoading={setIsLoading}
          isLoading={isLoading}
          groups={groups}
          dealerships={dealerships}
        />
      ),
    },
    {
      title: "status-report",
      userTypes: allTypes,
      component: (
        <StatusReport
          isDarkMode={isDarkMode}
          setDisplayComponent={setDisplayComponent}
          setPrevDisplay={setPrevDisplay}
          dealerships2={dealerships2}
          setIsLoading={setIsLoading}
        />
      ),
    },
    {
      title: "event-status-report",
      userTypes: allTypes,
      component: (
        <StatusReport
          isDarkMode={isDarkMode}
          setDisplayComponent={setDisplayComponent}
          setPrevDisplay={setPrevDisplay}
          dealerships2={dealerships2}
          setIsLoading={setIsLoading}
          eventScoped
        />
      ),
    },
    {
      title: "black-list",
      userTypes: allTypes,
      component: (
        <BlackList
          isDarkMode={isDarkMode}
          setDisplayComponent={setDisplayComponent}
          setPrevDisplay={setPrevDisplay}
          dealerships2={dealerships2}
          setIsLoading={setIsLoading}
        />
      ),
    },
    {
      title: "agent-bonus-report",
      userTypes: allTypes,
      component: (
        <AgentBonusReport
          isDarkMode={isDarkMode}
          setDisplayComponent={setDisplayComponent}
          setPrevDisplay={setPrevDisplay}
          dealerships2={dealerships2}
          setIsLoading={setIsLoading}
        />
      ),
    },
    {
      title: "bonus-confirmation-report",
      userTypes: allTypes,
      component: (
        <BonusConfirmation
          isDarkMode={isDarkMode}
          setDisplayComponent={setDisplayComponent}
          setPrevDisplay={setPrevDisplay}
          dealerships2={dealerships2}
          setIsLoading={setIsLoading}
        />
      ),
    },
    {
      title: "client-submission",
      userTypes: allTypes,
      component: (
        <ViewClientSubmission
          setIsDarkMode={setIsDarkMode}
          isDarkMode={isDarkMode}
        />
      ),
    },
  ];

  const getCurrentTab = () => {
    const activeComponent = Tabs.find(
      (tab) =>
        tab.title === displayComponent && tab.userTypes.includes(userType)
    )?.component;
    return (
      activeComponent || (
        <div className="d-flex justify-content-center appcountainer2">
          <h3 className="py-4">Not Found</h3>{" "}
        </div>
      )
    );
  };
  

  const getDealershipFilterData = async (dealer_id, provinces = null, navigation = true) => {
    // setIsLoading(true);
     isFetchingRef.current = true;
    try {
      const res = await fetch(ApiUrl + "/api/user/private-events-index", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ dealership_ids: dealer_id,
           type: filterOption ? filterOption : "",
           ...(provinces && { headerstate: provinces })
         }),
      });
      const data = await res.json();
      if (data.status === "success") {
        // toast.success(data.message);
        if (redirectPages.includes(displayComponent) && navigate) {
          navigate("/event-portal?page=events");
        }
        const newData = data.private_events;
        const newTotal = data.private_events?.total;

        const sortedUpdatedEvents =
          Object.keys(newData) &&
          Object.keys(newData).length > 0 &&
          Object.keys(newData)
            .sort(
              (a, b) => parseInt(a.split(" ")[1]) - parseInt(b.split(" ")[1])
            ) // Sort based on week number
            .reduce((sortedObj, week) => {
              sortedObj[week] = newData[week];
              return sortedObj;
            }, {});
         if (Object.keys(newData).length === 0) {
          setDataEnd(true);
        }
        else{
           setDataEnd(false);
        }
        setEvents(sortedUpdatedEvents);
        let totalEventss = 0;
          // Iterate over each week in the privateEvents object
          for (const week in sortedUpdatedEvents) {
            if (sortedUpdatedEvents.hasOwnProperty(week)) {
              // Add the number of events in the current week to the total
              totalEventss += sortedUpdatedEvents[week].length;
            }
          }
        if (totalEventss !== totalEvents){

          setStats(data);
          setTotalEvents(totalEventss);
        }
        setTotal(newTotal);
         setrepOptions2(
          data?.data.representative.length > 0 &&
          data.data.representative.map((user) => ({
            value: user.id,
            label: user.name,
          }))
        )
        
          setmanagers(
            data?.data.projectManagers.length > 0 &&
            data.data.projectManagers.map((user) => ({
              value: user.id,
              label: user.name,
            }))
          )
          setpackageOptions(
            data?.data.packages.length > 0 &&
            data.data.packages.map((user) => ({
              value: user.id,
              label: user.name,
            }))
          )

        if (key) {
          setSearchCache({
            [pageNo]: {
              cachedResponse: newData,
              cachedTotal: newTotal,
            },
          });
        } else {
          setPageCache({
            [pageNo]: {
              cachedResponse: newData,
              cachedTotal: newTotal,
            },
          });
          setDeleteStates(
            sortedUpdatedEvents &&
              Object.keys(sortedUpdatedEvents).map((key) =>
                sortedUpdatedEvents[key].map((item) => ({ [item.id]: false }))
              )
          );
          setDataLoaded(true);
          // setIsLoading(false);
        }
        
      } else {
        toast.error(data.message);
      }
    } catch (err) {
      // setIsLoading(false);
      toast.error(translations.alertMessages.wentWrong[language]);
    } 
    finally {
      // setIsLoading(false);
    isFetchingRef.current = false;

    }
    // finally {
    //   setIsLoading(false);
    // }
  };

  const getDealershipFilterDataDealersPage = async (dealer_id) => {
    if (userData && userData && userData.roles[0].name !== "Animator") {
      // setIsLoading(true);
      try {
        const res = await fetch(ApiUrl + "/api/user/get-all-dealership/", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ dealership_ids: dealer_id }),
        });
        const data = await res.json();
        if (data.status === "success") {
          // toast.success(data.message);
          // if (redirectPages.includes(displayComponent) && navigate) {
          //   navigate("/event-portal?page=events");
          // }

          const newData = data.list_of_dealership?.data;
          const newTotal = data.list_of_dealership?.total;

          setDealershipPageCache((prevCache) => ({
            ...prevCache,
            [DealershippageNo]: {
              cachedResponse: newData,
              cachedTotal: newTotal,
            },
          }));
          // Set state with new data
          setDealerships0(newData);
          // setDealershipSearch(newData);
          setTotalDealership(newTotal);
          setDeleteStatesDealership(newData.map(() => false));
        } else {
          toast.error(data.message);
        }
        // setIsLoading(false);
      } catch (err) {
        // setIsLoading(false);
        toast.error(translations.alertMessages.wentWrong[language]);
      } 
      // finally {
      //   setIsLoading(displayComponent === "events" ? true : false);
      // }
    }
  };


  return (
    <div>
      {isLoading && (
        <div className="splash-screen">
          <Loader />
        </div>
      )}
      <div className="event-portal">
        <AdminNav
          setDisplayComponent={setDisplayComponent}
          setEventTrigger={setEventTrigger}
          dealerships={dealerships}
          setDealerTrigger={setDealerTrigger}
          setToken={setToken}
          token={token}
          setIsDarkMode={setIsDarkMode}
          isDarkMode={isDarkMode}
          setPrevDisplay={setPrevDisplay}
          setIsLoading={setIsLoading}
          events={events}
          setEvents={setEvents}
          dealerships2={dealerships2}
          setDealerships2={setDealerships2}
          dealerships3={dealerships3}
          setDealerships3={setDealerships3}
          getDealershipFilterData={getDealershipFilterData}
          showDealerDropDown={showDealerDropDown}
          displayComponent={displayComponent}
          getDealershipFilterDataDealersPage={
            getDealershipFilterDataDealersPage
          }
          selectedOption={selectedOption}
          setSelectedOption={setSelectedOption}
          selectedProvince={selectedProvince}
          setSelectedProvince={setSelectedProvince}
          dealershipLabel={dealershipLabel}
          setDealershipLabel={setDealershipLabel}
          selectedOptionRef={selectedOptionRef}
          checkedFields={checkedFields}
          setCheckedFields={setCheckedFields}
        />
        {displayComponent && (
          <div
            className={`${
              getCurrentTab().type.name === "Signup" ||
              getCurrentTab().type.name === "EditUser" ||
              getCurrentTab().type.name === "ip" ||
              getCurrentTab().type.name === "op"
                ? ""
                : ""
            }`} /*style={{margin: "0px 15px !important", background: "#fff"}}*/
          >
            {/* {console.log(getCurrentTab())} */}
            {getCurrentTab()}
          </div>
        )}
      </div>
    </div>
  );
};

export default EventPortal;
